import React from 'react';
import styled from 'styled-components';
import useOnClickForceClubRegistrationPopup from 'Client/components/Overlays/ShopToClub/hooks/useOnClickForceClubRegistrationPopup';

const StyledShopToClubPageBlocker = styled.button`
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: ${({ theme }) => theme.zIndexShopToClubRegistration};
`;

const ShopToClubPageBlocker = () => {
    const { shouldRenderBlocker, onPageBlockerClick } = useOnClickForceClubRegistrationPopup();
    return shouldRenderBlocker ? (
        <StyledShopToClubPageBlocker onClick={event => onPageBlockerClick((event as unknown) as MouseEvent)} />
    ) : null;
};

export default ShopToClubPageBlocker;
